import React, { useState, useEffect } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import './classes/DraftDivvy.css';
import Loading from './Loading';
 import { configData } from "../config";
import { Helmet } from 'react-helmet';

const Draftdivvy = () => {
  const [selectedSalespeople, setSelectedSalespeople] = useState([]);
  const [results, setResults] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [confirmDivvyBtn, setshowConfirmDivvyBtn] = useState(true);
   const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [salesperson, setSalespersonlist] = useState([]);
  const [salespersonhtml, setSalespersonhtmllist] = useState('');
  const [appcount, setAppCount] = useState('');
  const app_url = configData.APP_URL;
  const handleCheckboxChange = (value) => {
    setSelectedSalespeople((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
    
  };
      useEffect(()=>{
          getsalespersonlist();
        },[])
      async function getsalespersonlist() {
    
        try {
         setIsLoading(true);
            const response = await fetch(
                app_url+'divvydraft/getdivvysalesperson',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
                setSalespersonlist(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
        
      }
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    
      setIsSubmitting(true);
      setshowConfirmDivvyBtn(true);
      setIsLoading(true);

      const postData = {sales:selectedSalespeople};
      try {
      const response = await fetch(app_url + 'divvydraft/rundivvy', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if(data.data.msg == "Success") {
        
         setIsSubmitting(false);
         setSalespersonhtmllist(data.data.result);
          setAppCount(data.data.app_count);
      }
         } catch (err) {
            
         }finally {
            setIsSubmitting(false); 
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    
    
  };
   const confirmDivvy = async () => {
    setShowConfirmDialog(true);
   }
 const handleCancel = () => {
      setShowConfirmDialog(false);
    };
    const handleConfirm = async () => {
      setShowConfirmDialog(false);
      setIsLoading(true);
    try {
      const response = await fetch(app_url + 'divvydraft/confirmdivvy', {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if(data.data.msg == "Success") {
        alert("Divvy Done!");
        setshowConfirmDivvyBtn(false);
        setIsLoading(false); 
       //  window.location.reload();
      }
    } catch (err) {
            
    }finally {
      
    }
  };

  const handleDownloadReport = async () => {
     try {
      const response = await fetch(app_url + 'divvydraft/downloaddivvy', {
        method: 'GET',
        headers: {
          'Content-Type': 'text/csv',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to download CSV file');
      }

      const data = await response.json();
      const csvUrl = data.data.csvUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
    } catch (error) {
      console.error(error);
    }
  };

  return (
         <>
                        {/* {isLoading ? (
                            <Loading />
                        ) : ( */}
    <div id="main">
      {isLoading && (
        <div className="loading-overlay">
          <img src={`${process.env.PUBLIC_URL}/images/ajax-loader.gif`} alt="loader" className='thankyou-loader' />
        </div>
      )}
      <div className="left"></div>

      <div className="center left-center">
        <Helmet><title>Run App Divvy For Draft</title></Helmet>
        <div className="draft-divvy-container">
          <h1>Run App Divvy For Draft</h1>
           {showConfirmDialog && (
              <div className="dialog-overlay">
                <div className="dialog-content">
                  <h2>Confirmation</h2>
                  <p>Are you sure to continue?</p>
                  <div className="dialog-actions">
                    <button onClick={handleConfirm}>Confirm</button>
                    <button onClick={handleCancel}>Cancel</button>
                  </div>
                </div>
              </div>
            )}
          <form onSubmit={handleSubmit}>
            <p>Choose Salespeople:</p>
            <ul className="sales-people-checkbox">
              {salesperson.length > 0 && ( 
              <>
              {salesperson.map(({ id, value, label }) => (
                <li>
                  <label>
                    <input
                      type="checkbox"
                      name="sales"
                      value={value}
                      checked={selectedSalespeople.includes(value)}
                      onChange={() => handleCheckboxChange(value)}
                    />
                    {label}
                  </label>
                </li>
              ))}
              </>
               )}
            </ul>
            <div style={{ clear: 'both', textAlign: 'center', paddingTop: '20px' }}>
              <input
                type="submit"
                name="btn"
                value={isSubmitting ? "Run" : "Run"}               
                disabled={isSubmitting} 
                onClick = {handleSubmit}
              />
            </div>
          </form>
        </div>
        {salespersonhtml && 
        (<div className="draft-divvy-result"> 
          {appcount && (

              <>
              <h2 style={{ color: '#004488' }}>New Apps waiting for first call:</h2>
               <div className="draft-divvy-result-buttons">
              {confirmDivvyBtn && (
                <>
              <input
                type="button"
                id="confirm_divvy"
                value="Confirm Divvy"
                onClick={confirmDivvy}
                className="confirm_divvy"
              />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>
            )}
              <input type="button" value="Download Report" onClick={handleDownloadReport} /></div></>
            )}
            
            <div dangerouslySetInnerHTML={{ __html: salespersonhtml }}></div></div>
           
        )
        }
       
      </div>

      <div className="right">
        <SalespersonSidebar />
      </div>
    </div>
    {/* )} */}
                    </>
  );
};

export default Draftdivvy;
